import { render } from "./Swiper.vue?vue&type=template&id=3552b0d8&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=js"
export * from "./Swiper.vue?vue&type=script&lang=js"

import "./Swiper.vue?vue&type=style&index=0&id=3552b0d8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Taiwan_Travel/Taiwan_Travel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3552b0d8"]])

export default __exports__